import { getBackendUrl } from "@Utils";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from "recharts";
import axiosWrapper from "../../services/axiosWrapper";
import IconComponent from "../icons";
import css from "./index.module.css";
import NoPortalDataIllustration from "./NoPortalData";
import { useTranslation } from "react-i18next";

function ProjectCollaborattorsTile({ filterData }) {
  const [pieData, setPieData] = useState([""]);
  const [currentPieData, setCurrentPieData] = useState([""]);
  const [dataKey, setDataKey] = useState(true);
  const [projectName, setProjectName] = useState("");
  const [projectId, setProjectId] = useState("");
  const modalVisibleData = useSelector((state) => state.portalDashboardData);
  const { t } = useTranslation();
  useEffect(() => {
    let params = {
      skip: filterData.ProjectCollaborattorsTile.skip,
      take: filterData.ProjectCollaborattorsTile.take,
    };
    if (!dataKey) {
      params = {
        skip: filterData.ProjectCollaborattorsTile.skip,
        projectId,
        take: filterData.ProjectCollaborattorsTile.take,
      };
    }
    axiosWrapper.post(`${getBackendUrl()}/portal/pieChart`, params).then((response) => {
      const b = response.data;
      setPieData(b.data);
      setCurrentPieData(b.data);
    });
  }, [filterData.ProjectCollaborattorsTile, dataKey]);

  const pieClickHandler = (args) => {
    setDataKey(false);
    setProjectId(args.id);
    setProjectName(args.name);
    filterData.ProjectCollaborattorsTile.skip = 0;
    filterData.ProjectCollaborattorsTile.take = filterData.ProjectCollaborattorsTile.skip + 5;

    if (!dataKey) {
      setProjectName(args.name);
      setCurrentPieData(
        args.org.slice(
          filterData.ProjectCollaborattorsTile.skip,
          filterData.ProjectCollaborattorsTile.skip + filterData.ProjectCollaborattorsTile.take,
        ),
      );
      setDataKey(!dataKey);
    }
  };

  const backClickHandler = () => {
    if (!dataKey) {
      setCurrentPieData(pieData);
      setDataKey(!dataKey);
    }
  };

  const COLORS = ["#e75555", "#ffe973", "#2c80ff", "#45cf80", "#ffb573"];
  const customTemplate = ({ payload }) => (
    <div className={css.pieTooltip}>{payload.length && `${payload[0].name} - ${payload[0].value} Orgs`}</div>
  );
  return currentPieData.length > 0 ? (
    <>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            dataKey={dataKey ? "value" : "uv"}
            isAnimationActive
            data={currentPieData}
            cx="50%"
            cy="50%"
            outerRadius={modalVisibleData.component ? "80%" : 100}
            fill="#8884d8"
            labelLine={false}
            onClick={(e) => pieClickHandler(e)}
            cursor="pointer"
          >
            {currentPieData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip content={customTemplate} />
        </PieChart>
      </ResponsiveContainer>
      <div
        className="pieCircleWrapper"
        style={{
          height: "100px",
          width: "100px",
          borderRadius: "50%",
          background: "#FFFF",
          position: "absolute",
          alignItems: "center",
          justifyContent: "center",
          start: 0,
          end: 0,
          top: 0,
          bottom: 0,
          margin: "auto",
          cursor: "pointer",
          display: dataKey ? "none" : "flex",
          flexDirection: "column",
        }}
        onClick={backClickHandler}
      >
        <div className={css.pieTextWrapper}>{projectName}</div>
        <IconComponent name="ArrowLeft" className="h-6" />
      </div>
    </>
  ) : (
    <NoPortalDataIllustration name={t("Project Collaborators")} />
  );
}

export default ProjectCollaborattorsTile;
